import { render, staticRenderFns } from "./MarcaProductoForm.vue?vue&type=template&id=6872d933&"
import script from "./MarcaProductoForm.vue?vue&type=script&lang=js&"
export * from "./MarcaProductoForm.vue?vue&type=script&lang=js&"
import style0 from "./MarcaProductoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports